function getTime () {
  let d = new Date()
  return `${d.getFullYear()}-${d.getMonth() + 1 <= 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1}-${d.getDate() <= 9 ? '0' + d.getDate() : d.getDate()} ${d.getHours() <= 9 ? '0' + d.getHours() : d.getHours()}:${d.getMinutes() <= 9 ? '0' + d.getMinutes() : d.getMinutes()}:${d.getSeconds() <= 9 ? '0' + d.getSeconds() : d.getSeconds()}`
}

function formatTime (time) {
  let d = new Date(Number(time))
  let today = new Date()
  if (today.getFullYear() > d.getFullYear()) {
    let year = d.getFullYear()
    let month = formatNum(d.getMonth() + 1)
    let day = formatNum(d.getDate())
    return `${year}-${month}-${day}`
  }
  if (today.getMonth() > d.getMonth() || today.getDate() > d.getDate()) {
    return `${d.getMonth() + 1}月${d.getDate()}日`
  }
  if (today.getHours() > d.getHours()) {
    return `今天 ${d.getHours()}:${d.getMinutes()}`
  }
  if (today.getMinutes() > d.getMinutes()) {
    return `${parseInt(today.getMinutes()) - parseInt(d.getMinutes())}分钟前`
  } else {
    return `${parseInt((today - d) / 1000)}秒前`
  }
}

function formatNum (n) {
  if (n > 9) return n
  return '0' + n
}

module.exports = {
  getTime,
  formatTime,
  formatNum
}



// WEBPACK FOOTER //
// ./src/util/utils.js